import React, { useState, useEffect } from 'react';
import { FormGroup, Label, Input, FormText } from 'reactstrap';

const FractionSlider = ({ value = 0, onChange, disabled = false }) => {
    console.log('FractionSlider value prop:', value);
    // Valores permitidos
    const customValues = [0, 1 / 8, 1 / 4, 3 / 8, 1 / 2, 5 / 8, 3 / 4, 7 / 8, 1];

    // Estado para el valor actual
    const [currentValue, setCurrentValue] = useState(Number(value));

    // Actualizar currentValue cuando cambia el prop value
    useEffect(() => {
        const numValue = Number(value);
        console.log('Updating currentValue to:', numValue);
        setCurrentValue(numValue);
    }, [value]);

    // Función para convertir valor a fracción string
    const valueToFraction = (value) => {
        const fractions = {
            0: '0',
            0.125: '1/8',
            0.25: '1/4',
            0.375: '3/8',
            0.5: '1/2',
            0.625: '5/8',
            0.75: '3/4',
            0.875: '7/8',
            1: '1'
        };
        return fractions.hasOwnProperty(value) ? fractions[value] : '0';
    };

    // Manejar cambio del slider
    const handleSliderChange = (e) => {
        if (!disabled) {
            const index = parseInt(e.target.value);
            setCurrentValue(customValues[index]);
            onChange(customValues[index])
        }
    };

    // Obtener el índice actual para el input range
    const currentIndex = customValues.indexOf(currentValue);
    console.log('currentValue:', currentValue, 'currentIndex:', currentIndex);

    return (
        <FormGroup>
            <Input
                id="fractionSlider"
                type="range"
                min="0"
                max={customValues.length - 1}
                value={currentIndex}
                onChange={handleSliderChange}
                step="1"
                className="w-100"
            />

            <div className="d-flex justify-content-between mt-2">
                {customValues.map((value, index) => (
                    <span
                        key={value}
                        className="small text-muted"
                        style={{
                            cursor: 'pointer',
                            color: value === currentValue ? '#007bff' : '#6c757d',
                            fontWeight: value === currentValue ? 'bold' : 'normal'
                        }}
                        onClick={() => setCurrentValue(value)}
                    >
                        {valueToFraction(value)}
                    </span>
                ))}
            </div>
        </FormGroup>
    );
};

export default FractionSlider;